<template lang="pug">
  .lei-issuer
    a.name(@click="openModal")
      span.value(:class="{'active': !challengeMode}") {{name}}
    lei-code-link.value(v-if="lei" :lei="lei")
</template>
<script>
import { mapMutations, } from 'vuex'
import { TOGGLE_ISSUER_MODAL, } from '@/store/modules/record/mutations-types'
import Challenge from '@/mixins/challenge'
import LeiCodeLink from './LeiCodeLink'

export default {
  components: { LeiCodeLink, },
  mixins: [ Challenge, ],
  props: {
    leiIssuer: {
      type: [ Object, Array, String, ],
      required: true,
    },
  },
  computed: {
    name () {
      return `${this.leiIssuer.name} (${this.leiIssuer.marketingName})`
    },
    lei () {
      return this.leiIssuer.lei
    },
  },
  methods: {
    openModal () {
      if (!this.challengeMode) this.toggleModal(true)
    },

    ...mapMutations('record', {
      toggleModal: TOGGLE_ISSUER_MODAL,
    }),
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../../assets/styles/variables.styl"

  .lei-issuer
    display flex
    flex-direction column
    align-items flex-start
    line-height 1.5

    .name
      margin-bottom 5px

    .value
      color $default-color-bold-1
      font-weight 500
      cursor pointer
      line-height 1.5rem
      border-bottom 1px solid $turquoise-color
      transition all .2s ease

      &.active:hover
        color $turquoise-color
        border-bottom 1px solid $turquoise-color

</style>



// WEBPACK FOOTER //
// src/components/record-details/table-components/LeiIssuerBlock.vue